import React, {useEffect, useState} from "react";
import DashboardMenu from "../../layout/dashboardMenu";
import Loader from "../../../Loader/Loader";
import {toast} from "react-toastify";
import Header from "../../layout/header";
import { useHistory } from 'react-router-dom';
import SuccessModal from "../../CustomModal/Success";
import FailedModal from "../../CustomModal/Failed";

const AddDealerPoc = ({
    updateDealerPocDetails,
    getDealerPocDetails,
    updatePocDetails = [],
    getPocDetails = [],
    match
}) => {
    const history = useHistory();
    const [countToOpenModal, setCountToOpenModal] = useState(0);
    const [isSuccessModalOpen, setIsSuccessModalOpen] = useState(false);
    const [isFailedModalOpen, setIsFailedModalOpen] = useState(false);
    const [userMessage, setUserMessage] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [redirectUrl, setRedirectUrl] = useState("");
    const [pocDetails, addPOCDetails] = useState([
        {
            name: "",
            email_id: "",
            contact_no: "",
            designation: "",
            other_designation: ""
        },
    ]);

    useEffect(() => {
        (async () => {
            setIsLoading(true);
            const response = await getDealerPocDetails(match?.params?.dealer_id);
            if (response && response.length > 0) {
                addPOCDetails(response);
            }
            setIsLoading(false);
        })();
    }, [getDealerPocDetails, match]);

    const handleRemovePOC = (e, index) => {
        const list = [...pocDetails];
        list.splice(index, 1);
        addPOCDetails(list);
        e.preventDefault();
    };

    const handleAddPOC = () => {
        addPOCDetails([
            ...pocDetails,
            {
                name: "",
                email_id: "",
                contact_no: "",
                designation: "",
                other_designation: "",
            },
        ]);
    };

    const handlePocInput = (val, field, index) => {
        const list = [...pocDetails];
        if (list[index]) {
            list[index][field] = val;
            addPOCDetails(list);
        }
    };

    useEffect(() => {
        if (getPocDetails && getPocDetails.length > 0) {
            setIsLoading(true);
            addPOCDetails(getPocDetails);
            setIsLoading(false);
        }
    }, [getPocDetails]);

    useEffect(() => {
        setIsFailedModalOpen(false);
        setIsSuccessModalOpen(false);
        if (parseInt(updatePocDetails?.status) === 200) {
            setCountToOpenModal(countToOpenModal + 1);
            setIsSuccessModalOpen(true);
            setUserMessage(updatePocDetails?.message);
        } else if (updatePocDetails?.status !== undefined && updatePocDetails?.status !== 200) {
            setCountToOpenModal(countToOpenModal + 1);
            setIsFailedModalOpen(true);
            setUserMessage(updatePocDetails?.message);
        }
    }, [updatePocDetails]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        const designations = new Set();
        let hasDuplicate = false;
        pocDetails.forEach((poc) => {
            if (designations.has(poc.designation)) {
                hasDuplicate = true;
                return;
            }
            designations.add(poc.designation);
        });

        if (hasDuplicate) {
            toast.error("Please ensure each POC has a unique designation.");
            return false;
        }

        setIsLoading(true);
        await updateDealerPocDetails({ poc_data: pocDetails }, match?.params?.dealer_id);
        setIsLoading(false);
        setRedirectUrl("dealer-list/ncd");
    };

    return (
        <>
            <SuccessModal
                isOpen={isSuccessModalOpen}
                msg={userMessage}
                url={redirectUrl}
            />
            <FailedModal
                isOpen={isFailedModalOpen}
                msg={userMessage}
                countToOpenModal={countToOpenModal}
            />
            <Loader isLoading={isLoading} />
            <div id="wrapper">
                <DashboardMenu />
                <div id="content-wrapper" className="d-flex flex-column">
                    <div id="content">
                        <Header title={"Add/Edit POC"} />
                        <div className="container-fluid">
                            <div className="d-sm-flex align-items-center justify-content-between">
                                <h1 className="h3 mb-0 text-black-100 hide">Add Dealer</h1>
                            </div>
                            <form onSubmit={handleSubmit}>
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className="mb-0 bg-white">
                                            <div className="div-com-header">
                                                <div className="card-body">
                                                    <div className="user">
                                                        <div className="form-group row">
                                                            <div className="col-md-12">
                                                                <div className="d-sm-flex align-items-center justify-content-between com-sub-heading">
                                                                    <h1 className="h3 mb-0 text-black-100">POC Details</h1>
                                                                </div>
                                                                <div className="mb-4 bg-white">
                                                                    <div className="hide card-header bg-lightGreen-active">POC Details</div>
                                                                    <div className="card-body">
                                                                        <div className="user">
                                                                            <div className="form-group row">
                                                                                {pocDetails.map((val, i) => (
                                                                                    <React.Fragment key={i}>
                                                                                        <div className="col-md-6 float-field">
                                                                                            <input
                                                                                                type="text"
                                                                                                className="form-control form-control-user"
                                                                                                placeholder=" "
                                                                                                onChange={(e) => {
                                                                                                    handlePocInput(e.target.value, "name", i);
                                                                                                }}
                                                                                                required
                                                                                                value={val?.name}
                                                                                            />
                                                                                            <label className="large-label float-lb">
                                                                                                Poc Name <i className="bi bi-asterisk astrick-icon"></i>
                                                                                            </label>
                                                                                        </div>
                                                                                        <div className="col-sm-6 float-field">
                                                                                            <input
                                                                                                type="email"
                                                                                                className="form-control form-control-user"
                                                                                                placeholder=" "
                                                                                                onChange={(e) => {
                                                                                                    handlePocInput(e.target.value, "email_id", i);
                                                                                                }}
                                                                                                required
                                                                                                value={val?.email_id}
                                                                                            />
                                                                                            <label className="large-label float-lb">
                                                                                                Email Id <i className="bi bi-asterisk astrick-icon"></i>
                                                                                            </label>
                                                                                        </div>
                                                                                        <div className="col-sm-6 float-field">
                                                                                            <input
                                                                                                type="number"
                                                                                                className="form-control form-control-user"
                                                                                                placeholder=" "
                                                                                                onChange={(e) => {
                                                                                                    const inputValue = e.target.value;
                                                                                                    const mobileNumber = inputValue.replace(/\D/g, "");
                                                                                                    const trimmedMobileNumber = mobileNumber.slice(0, 10);
                                                                                                    e.target.value = trimmedMobileNumber;
                                                                                                    handlePocInput(trimmedMobileNumber, "contact_no", i);
                                                                                                }}
                                                                                                required
                                                                                                value={val?.contact_no}
                                                                                                pattern={"[1-9]{1}[0-9]{9}"}
                                                                                            />
                                                                                            <label className="large-label float-lb">
                                                                                                Mobile Number <i className="bi bi-asterisk astrick-icon"></i>
                                                                                            </label>
                                                                                        </div>
                                                                                        <div className="col-md-6 float-field">
                                                                                            <select
                                                                                                className="form-control form-control-user"
                                                                                                onChange={(e) => {
                                                                                                    handlePocInput(e.target.value, "designation", i);
                                                                                                }}
                                                                                                required
                                                                                                value={val?.designation}
                                                                                            >
                                                                                                <option value="">Select Designation</option>
                                                                                                <option value="Owner">Owner</option>
                                                                                                <option value="VP">VP</option>
                                                                                                <option value="GM">GM</option>
                                                                                                <option value="Sale Manager">Sale Manager</option>
                                                                                                <option value="Marketing Manager">Marketing Manager</option>
                                                                                                <option value="RTO Head">RTO Head</option>
                                                                                                <option value="Other">Other</option>
                                                                                            </select>
                                                                                            <label className="large-label float-lb">
                                                                                                Designation <i className="bi bi-asterisk astrick-icon"></i>
                                                                                            </label>
                                                                                        </div>
                                                                                        {pocDetails[i]['designation'] === 'Other' &&
                                                                                            <div className="col-sm-6 float-field">
                                                                                                <input
                                                                                                    type="text"
                                                                                                    className="form-control form-control-user"
                                                                                                    placeholder=" "
                                                                                                    onChange={(e) => {
                                                                                                        handlePocInput(e.target.value, "other_designation", i);
                                                                                                    }}
                                                                                                    required
                                                                                                    value={val?.other_designation}
                                                                                                />
                                                                                                <label className="large-label float-lb">
                                                                                                    Designation <i className="bi bi-asterisk astrick-icon"></i>
                                                                                                </label>
                                                                                            </div>
                                                                                        }
                                                                                        <div className="btn-box mb-4" style={{ width: "100%" }}>
                                                                                            {pocDetails.length !== 1 && (
                                                                                                <button
                                                                                                    onClick={(e) => handleRemovePOC(e, i)}
                                                                                                    className="btn btn-sm btn-danger ml-3 btn-ar"
                                                                                                >
                                                                                                    Remove
                                                                                                </button>
                                                                                            )}
                                                                                            {pocDetails.length - 1 === i && (
                                                                                                <button
                                                                                                    className="btn btn-sm btn-primary ml-3 btn-ar"
                                                                                                    onClick={handleAddPOC}
                                                                                                >
                                                                                                    Add
                                                                                                </button>
                                                                                            )}
                                                                                        </div>
                                                                                    </React.Fragment>
                                                                                ))}
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-sm-12 mt-4">
                                    <button className="btn btn-primary btn-user btn-block submit-btn">
                                        Submit
                                    </button>
                                </div>
                            </form>
                            <img src="../img/leads.gif" width="90%" />
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default AddDealerPoc;